export interface Win32Policy {
    DisablePst: boolean;
    PSTDisableGrow: boolean;
    DisableIMAP: boolean;
    DisablePOP3: boolean;
    DisableExchange: boolean;
    DisableExchangeConsumerAccounts: boolean;
    DisableEAS: boolean;
    DisableOtherTypes: boolean;
    ZeroConfigExchange: boolean;
}

const win32Policy: Win32Policy = {
    DisablePst: false,
    PSTDisableGrow: false,
    DisableIMAP: false,
    DisablePOP3: false,
    DisableExchange: false,
    DisableExchangeConsumerAccounts: false,
    DisableEAS: false,
    DisableOtherTypes: false,
    ZeroConfigExchange: false,
};

export function setWin32Policy(policy: Win32Policy): void {
    Object.assign(win32Policy, policy);
}

export function getWin32Policy(): Win32Policy {
    return win32Policy;
}
